import { render, staticRenderFns } from "./ModerationBlank.vue?vue&type=template&id=2240979e&scoped=true"
import script from "./ModerationBlank.vue?vue&type=script&lang=js"
export * from "./ModerationBlank.vue?vue&type=script&lang=js"
import style0 from "./ModerationBlank.vue?vue&type=style&index=0&id=2240979e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2240979e",
  null
  
)

export default component.exports